import {OnboardingWizardStep} from "@/lib/types/accounts.ts";

import {StepContent} from "../step/Step";
import {StepTeamBody} from "./StepTeamBody";

export const STEP_TEAM: StepContent = {
  name: OnboardingWizardStep.TEAM,
  title: "Invite your team.",
  subtitle: "Which team members do you need to collaborate with?",
  body: StepTeamBody,
};
